import { render, staticRenderFns } from "./PublicacionPoliticasNormasCodigos.vue?vue&type=template&id=2a2b1a37&"
import script from "./PublicacionPoliticasNormasCodigos.vue?vue&type=script&lang=js&"
export * from "./PublicacionPoliticasNormasCodigos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports